// extracted by mini-css-extract-plugin
export default {"transactionAccess":"styles_transactionAccess__Ury3J","label":"styles_label__Km7Nw","accessSelect":"styles_accessSelect__wqnWF"};